/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:992px){.room-wide[_ngcontent-%COMP%]{display:flex}.room-wide[_ngcontent-%COMP%]   .establishment-image[_ngcontent-%COMP%]{min-width:400px}.room-wide[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{flex-grow:1;display:flex;flex-direction:column}.room-wide[_ngcontent-%COMP%]   .txt5[_ngcontent-%COMP%]{flex-grow:1}}.number-accomodations-selection[_ngcontent-%COMP%]{flex-grow:1;margin-right:10px}"];
export { styles as styles };
